<div class="row">
    <div class="col-sm-9">
        <h2>{{ 'QR_LANDING_PAGE.TITLE' | translate }}</h2>
    </div>
    <div class="col-sm-3" [formGroup]="qrLandingForm">
        <ng-select [items]="selectedLanguage" [searchable]="true" bindLabel="lable" bindValue="value" required
            formControlName="language" (change)="onLanguageChange()" [clearable]="false"
            [disabled]="isLoading || isSaving"></ng-select>
    </div>
</div>
<nb-card>
    <nb-card-body style="position: relative">
        <p class="text-muted mb-3">
            {{ 'QR_LANDING_PAGE.HELP' | translate }}
        </p>
        <div *ngIf="isLoading" class="text-center py-4">
            <nb-spinner size="medium"></nb-spinner>
            <p class="mt-2 text-muted mb-0">Loading content...</p>
        </div>
        <div class="col-sm-12" [formGroup]="qrLandingForm" [class.opacity-50]="isLoading">
            <angular-editor [placeholder]="'Enter text here...'" class="editor-container" formControlName="content"
                [config]="editorConfig"></angular-editor>
        </div>
        <div *ngIf="qrLandingForm?.get('content')?.hasError('required') && (qrLandingForm?.get('content')?.touched || isSubmitted)" class="text-danger">
            Content is required.
        </div>
    </nb-card-body>
</nb-card>

<button type="submit" style="float: right" class="btn btn-primary px-4"
    [disabled]="qrLandingForm.invalid || isSaving || isLoading"
    (click)="onSave()">
    {{ isSaving ? 'Saving...' : 'Save' }}
</button>
